<template>
  <div>
    <el-dialog
      width="375px"
      title="新增高代渠道"
      :visible.sync="addModal"
      append-to-body
    >
      <el-form :model="addData" class="demo-form-inline" label-position="top">
        <el-form-item label="高代ID">
          <el-input v-model="addData.agent_id" placeholder="高代ID"></el-input>
        </el-form-item>
        <el-form-item label="第三方支付平台">
          <el-select
            v-model="addData.method_id"
            style="width:100%"
            placeholder="三方渠道"
          >
            <!-- @change="urlPush" -->
            <el-option
              :label="method.name"
              :value="method.id"
              v-for="method in methodList"
              :key="method.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="域名">
          <el-input v-model="addData.url" placeholder="域名"></el-input>
        </el-form-item>
        <el-form-item label="通知IP">
          <el-input
            type="textarea"
            v-model="addData.notify_ip"
            placeholder="通知IP"
          ></el-input>
        </el-form-item>
        <el-form-item label="三方商戶號">
          <el-input
            v-model="addData.merchant_no"
            placeholder="三方商戶號"
          ></el-input>
        </el-form-item>
        <el-form-item label="三方密鑰">
          <el-input
            v-model="addData.merchant_api_key"
            placeholder="三方密鑰"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addModal = false" class="btn">關閉</div>
        <div @click="confirmAdd" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      width="375px"
      title="編輯高代渠道"
      :visible.sync="editModal"
      append-to-body
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="高代渠道" name="1">
          <el-form :model="currentData" class="demo-form-inline">
            <el-form-item label="渠道名稱">
              <el-input
                v-model="currentData.alias"
                placeholder="渠道名稱"
              ></el-input>
            </el-form-item>
            <el-form-item label="三方通知地址">
              <el-input
                disabled
                v-model="currentData.t_notify_url"
                placeholder="三方通知地址"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="渠道密鑰"
          name="2"
          v-if="currentData.agent_payment_key"
        >
          <el-form :model="currentData" class="demo-form-inline">
            <el-form-item label="三方商戶號">
              <el-input
                v-model="currentData.agent_payment_key.merchant_no"
                placeholder="三方商戶號"
              ></el-input>
            </el-form-item>
            <el-form-item label="三方密鑰">
              <el-input
                v-model="currentData.agent_payment_key.merchant_api_key"
                placeholder="三方密鑰"
              ></el-input>
            </el-form-item>
            <el-form-item label="域名">
              <el-input
                v-model="currentData.agent_payment_key.url"
                placeholder="域名"
              ></el-input>
            </el-form-item>
            <el-form-item label="通知IP">
              <el-input
                type="textarea"
                v-model="currentData.agent_payment_key.notify_ip"
                placeholder="通知IP"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editModal = false" class="btn">關閉</div>
        <div @click="confirmEdit" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item
        label="商戶號/用戶名"
        v-if="$store.state.userStatus != 'agent'"
      >
        <el-input
          v-model="searchData.search"
          placeholder="商戶號/用戶名"
        ></el-input>
      </el-form-item>
      <el-form-item label="三方渠道">
        <el-select v-model="searchData.method_id" placeholder="三方渠道">
          <el-option label="全部" value=""></el-option>
          <el-option
            :label="method.name"
            :value="method.id"
            v-for="method in methodList"
            :key="method.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <el-button
      size="mini"
      @click="
        addModal = true;
        addData = {};
        getMethod();
      "
      >新增高代渠道</el-button
    >

    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        :key="1"
        header-align="center"
        align="center"
        prop="id"
        label="渠道編號"
      >
      </el-table-column>
      <el-table-column
        :key="2"
        header-align="center"
        align="center"
        prop="agent_id"
        label="高代ID"
      >
      </el-table-column>
      <el-table-column
        :key="3"
        header-align="center"
        align="center"
        prop="type_alias"
        label="用戶名稱"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            {{ scope.row.user.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="4"
        header-align="center"
        align="center"
        prop="agent_method_key_id"
        label="key_id"
      >
      </el-table-column>
      <el-table-column
        :key="5"
        header-align="center"
        align="center"
        prop="type_alias"
        label="大渠道名稱"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.method">
            {{ scope.row.method.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="6"
        header-align="center"
        align="center"
        prop="alias"
        label="渠道名稱"
      >
      </el-table-column>
      <el-table-column
        :key="7"
        header-align="center"
        align="center"
        prop="type_alias"
        label="啟用狀態"
      >
        <template slot-scope="scope">
          <div>
            <el-switch
              @change="
                changeSwitch(
                  scope.row,
                  'status',
                  '啟用狀態',
                  `/back/payment_method/agents/${scope.row.id}/status`
                )
              "
              :value="scope.row.status == 1"
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-if="$permission('users.list.enable')"
            >
            </el-switch>
            <p v-else>{{ scope.row.status == 1 ? "開啟" : "關閉" }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="8"
        header-align="center"
        align="center"
        prop="type_alias"
        label="操作"
        width="200"
      >
        <template slot-scope="scope">
          <div>
            <el-button size="mini" @click="editData(scope.row)">編輯</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addData: {},
      searchData: {},
      saveData: false,
      inSearch: false,
      page: 1,
      pagination: {},
      currentData: {},
      editModal: false,
      activeName: "1",
      dataList: [],
      methodList: [],
      addModal: false,
      paymentList: []
    };
  },
  watch: {
    "addData.method_id"() {
      this.paymentList.forEach(e => {
        console.log(e);
        if (e.id == this.addData.method_id) {
          this.addData.url = e.channel.url || "null";
        }
      });
    },
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    getMethod() {
      this.$http
        .get(`/back/methods?type=payment&agentId=undefined`)
        .then(res => {
          if (res.data.code == 0) {
            this.paymentList = res.data.data;
          }
        });
    },
    confirmAdd() {
      if (!this.addData.agent_id) {
        this.$message.error("請輸入高代ID");
        return;
      }
      if (!this.addData.method_id) {
        this.$message.error("請選擇第三方支付平台");
        return;
      }
      if (!this.addData.url) {
        this.$message.error("請輸入域名");
        return;
      }
      this.$http.post(`/back/payment_method/agents`, this.addData).then(res => {
        if (res.data.code == 0) {
          this.getData();
          this.addModal = false;
          this.$message.success("成功");
        }
      });
    },
    confirmEdit() {
      this.$http
        .put(`/back/payment_method/agents/${this.currentData.id}/status`, {
          agent_payment_key: this.currentData.agent_payment_key,
          alias: this.currentData.alias
        })
        .then(res => {
          if (res.data.code == 0) {
            this.getData();
            this.editModal = false;
            this.$message.success("成功");
          }
        });
    },
    editData(data) {
      let currentData = JSON.parse(JSON.stringify(data));
      this.currentData = currentData;
      this.editModal = true;
    },
    changeSwitch(data, assign, title, api) {
      this.$alert(
        `確定${data[assign] == 1 ? "關閉" : "開啟"}${title}?`,
        title,
        {
          showCancelButton: true,
          confirmButtonText: "確定",
          cancelButtonText: "取消",
          beforeClose: (method, instance, done) => {
            let sendData = { id: data.id };
            sendData[assign] = data[assign] == 1 ? 0 : 1;
            if (method == "confirm") {
              this.$http.put(`${api}`, sendData).then(res => {
                if (res.data.code == 0) {
                  this.$message.success("成功");
                  this.getData();
                  done();
                } else {
                  done();
                }
              });
            } else {
              done();
            }
          }
        }
      );
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .get(`/back/payment_method/agents`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
    this.$http.get(`/back/methods/select?type=payment`).then(res => {
      if (res.data.code == 0) {
        this.methodList = res.data.data;
      }
    });
  }
};
</script>
